<template>
    <div>
        <div class="footer" v-if="width >= 1200" style="background: #112138;color:#fff;padding:30px 0">
            <div style="width:1440px;margin:0 auto;">
                <!--  -->
                <div class="top-t">
                <div class="top-leftOne">
                    <div class="logo">
                        <img src="../assets/img/toplogo.png" alt="">
                    </div>

                    <div class="address">售后服务热线：</div>
                    <div class="address">{{ obj.afterSaleHotLine }}</div>
                    <div class="address">心理咨询热线：</div>
                    <div class="address">{{ obj.psychologyConsultHotLine }}</div>

                </div>
                <div class="top-left">
                    <div style="font-size: 20px;cursor: pointer" @click="$router.push('/news')">走进瑞阳心语</div>
                    <div class="self-adaption">
                        <div @click="$router.replace('/news?activeName=1')">公司简介</div>
                        <div @click="$router.replace('/news?activeName=2')">公司荣誉</div>
                        <div @click="$router.replace('/news?activeName=3')">科研成果</div>
                        <div @click="$router.replace('/news?activeName=4')">合作机构</div>
                    </div>
                </div>
                <div class="top-left" style="width:15%">
                    <div style="font-size: 20px;cursor: pointer" @click="$router.replace('/product')">服务体系</div>
                    <div class="no-adaption" style="cursor: pointer">
                        <div @click="$router.replace('/product?activeName=1')">社会心理服务体系</div>
                        <div @click="$router.replace('/product?activeName=2')">学校心理服务体系</div>
                        <div @click="$router.replace('/product?activeName=3')">EAP心理服务体系</div>
                        <div @click="$router.replace('/product?activeName=4')">社会工作和公益服务体系</div>
                    </div>
                </div>
                <div class="top-left">
                    <div style="font-size: 20px;cursor: pointer"  @click="$router.replace('/case')">产业体系</div>
                    <div class="no-adaption" style="cursor: pointer">
                        <div @click="$router.replace('/case?activeName=1')">心智谷</div>
                        <div @click="$router.replace('/case?activeName=2')">心理+</div>
                    </div>
                </div>
                <div class="top-left" style="width:15%;cursor: pointer" @click="$router.replace('/goin')">
                    <div style="font-size: 20px">业务体系</div>
                    <div class="no-adaption" style="cursor: pointer">
                        <div @click="$router.replace('/goin?activeName=1')">天网-心理健康智慧云平台建设</div>
                        <div @click="$router.replace('/goin?activeName=2')">地网-心理服务物理空间建设</div>
                        <div @click="$router.replace('/goin?activeName=3')">人网-人才培养与人才选拔</div>
                        <div @click="$router.replace('/goin?activeName=4')">和网-心理健康专业服务</div>
                    </div>
                </div>
                <div class="top-left">
                    <div style="font-size: 20px;cursor: pointer" @click="$router.replace('/download')">心闻资讯</div>
                    <div class="no-adaption" style="cursor: pointer">
                        <div @click="$router.replace('/download?index=1')">参观指导</div>
                        <div @click="$router.replace('/download?index=2')">前沿动态</div>
                        <div @click="$router.replace('/download?index=3')">学术交流</div>
                        <div @click="$router.replace('/download?index=4')">实践在线</div>
                        <div @click="$router.replace('/download?index=5')">信息发布</div>
                    </div>
                </div>
            </div>
            <div class="icp">鲁ICP备19037074号-9</div>
            </div>
        </div>
        <div class="footer" v-else>
            <el-collapse v-model="activeNames" @change="handleChange">
                <el-collapse-item title="首页" name="1">
                    <div @click="$router.push('/download')">新闻动态</div>
                    <div @click="$router.replace('/news?activeName=1')">公司简介</div>
                    <div @click="$router.replace('/news?activeName=2')">公司荣誉</div>
                </el-collapse-item>
                <el-collapse-item title="走进瑞阳心语" name="2">
                    <div @click="$router.replace('/news?activeName=1')">公司简介</div>
                    <div @click="$router.replace('/news?activeName=2')">公司荣誉</div>
                    <div @click="$router.replace('/news?activeName=3')">科研成果</div>
                    <div @click="$router.replace('/news?activeName=4')">合作机构</div>
                </el-collapse-item>
                <el-collapse-item title="服务体系" name="3">
                    <div @click="$router.replace('/product?activeName=1')">社会心理服务体系</div>
                        <div @click="$router.replace('/product?activeName=2')">学校心理服务体系</div>
                        <div @click="$router.replace('/product?activeName=3')">EAP心理服务体系</div>
                        <div @click="$router.replace('/product?activeName=4')">社会工作和公益服务体系</div>
                </el-collapse-item>
                <el-collapse-item title="产业体系" name="4">
                    <div @click="$router.replace('/case?activeName=1')">心智谷</div>
                    <div @click="$router.replace('/case?activeName=2')">心理＋</div>
                </el-collapse-item>
                <el-collapse-item title="业务体系" name="5">
                    <div @click="$router.replace('/goin?activeName=1')">天网--心理健康智慧云平台建设</div>
                    <div @click="$router.replace('/goin?activeName=2')">地网--心理服务物理空间建设</div>
                    <div @click="$router.replace('/goin?activeName=3')">人网--人才培养与人才选拔</div>
                    <div @click="$router.replace('/goin?activeName=4')">和网--心理健康专业服务</div>
                </el-collapse-item>
                <el-collapse-item title="心闻资讯" name="6">
                        <div @click="$router.replace('/download?index=1')">参观指导</div>
                        <div @click="$router.replace('/download?index=2')">前沿动态</div>
                        <div @click="$router.replace('/download?index=3')">学术交流</div>
                        <div @click="$router.replace('/download?index=4')">实践在线</div>
                        <div @click="$router.replace('/download?index=5')">信息发布</div>
                </el-collapse-item>
            </el-collapse>
            <div class="bottom">
                <img src="../assets/move/logo.png" alt="">
                <div>
                    <div>售后服务热线:{{ obj.afterSaleHotLine }}</div>
                    <div>心理咨询热线:{{ obj.psychologyConsultHotLine }}</div>
                </div>
            </div>
            <div class="icp-m">鲁ICP备19037074号-9</div>
        </div>
    </div>
</template>
<script>
import { getSite } from '../api/api'
export default {
    name: "Footer",
    data() {
      return {
        width:document.documentElement.clientWidth,
        activeNames: [],
        obj:{}
      };
    },
    mounted () {
      window.onresize = () => {
        return (() => {
          this.width = document.documentElement.clientWidth // 宽
          console.log(this.width,'this.widththis.widththis.width')
        })()
      }
        getSite().then(res => {
            this.obj = res.data.data
        })


    },
    methods: {
        handleChange(val) {
        // console.log(val);
        }
    }
};
</script>
<style scoped>
@import url('../assets/font/font.css');
    * {
        margin: 0;
        padding: 0;
        font-family: Microsoft YaHei;
      font-size: 16px;
    }
    @media (min-width:1200px) {
        #footer {
        box-sizing: border-box;
        width: 100%;
        /* height: 50vh; */
        color: #fff;
        background: #112138;
        overflow: hidden;
        padding: 60px 0;
        font-family: Microsoft YaHei;
          font-size: 16px;
        }
        .top-t{
            width: 100%;
            height: 83%;
            display: flex;
            justify-content: space-evenly;
        }
        .top-leftOne{
            width: 20%;
            height: 100%;
        }
        .logo {
            /* width: 100%;
            height: 30%; */
            margin-bottom: 20px;
        }
        .logo img{
            width: 221px;
            height: 80px;
        }
        .address{
            height: 15%;
            width: 100%;
        }
        .top-left{
            width: 12%;
            height: 100%;
        }
        .self-adaption{
            margin-top: 10px;
            height: 80%;
            line-height: 40px;
            color: #fff;
            font-size: 16px;
          cursor: pointer;
        }
        .no-adaption{
            margin-top: 10px;
            height: 80%;
            line-height: 40px;
            color: #fff;
            font-size: 16px;
        }
        .bottom-t{
            width: 100%;
            height: 15%;
        }
        .bottom-zi{
            width: 100%;
            height: 50%;
        }
        .icp{
            width: 100%;
            text-align: center;
            color: #fff;
            opacity: 0.8;
            font-size: 14px;
            margin-top: 20px;
        }
    }
    @media(max-width:1200px) {
        .footer{
            width: 100%;
            height: 380px;
            background: #112138;
        }
        ::v-deep .el-collapse-item__header{
            background: #112138;
            color: #fff;
            border-width: 0px 0px 1px 0px;
            border-style: solid;
            border-color: rgba(255, 255, 255, 0.1);
            box-sizing: border-box;
            padding: 0 20px;
        }
        ::v-deep .el-collapse-item__content{
            background: #112138;
            color: #fff;
            box-sizing: border-box;
            padding: 0 20px;

        }
        .bottom{
            display: flex;
            justify-content: space-around;
            color: #fff;
            margin-top: 20px;
            background-color: #112138;
        }
        .icp-m{
            width: 100%;
            text-align: center;
            color: #fff;
            opacity: 0.8;
            font-size: 12px;
            margin-top: 10px;
        }
    }

</style>

